<template>
    <div v-route-title="'门户管理'">
        <div class="database-view">
            <div class="header-view pr">
                <span class="huishouzhan_title">门户管理</span>
                <div class="btn-layer">
                    <el-button @click="addRow" type="primary" icon="el-icon-circle-plus-outline">添加门户</el-button>
                </div>
            </div>
            <el-form class="search-form" inline :model="searchModel">
                <el-form-item>
                    <el-input v-model="searchModel.id" type="number" style="width: 90px;" placeholder="门户ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="searchModel.nameLike" style="width: 120px;" placeholder="门户名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
            <div v-if="data">
                <el-table class="yq-table" :data="data.content" style="width: 100%">
                    <el-table-column
                            type="index"
                            :index="indexMethod">
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            label="ID">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="门户名称">
                    </el-table-column>
                    <el-table-column
                            label="创建时间">
                        <pretty-date-time slot-scope="scope" :value="scope.row.createdAt"/>
                    </el-table-column>
                    <el-table-column
                            label="创建用户">
                        <span slot-scope="scope">{{scope.row.creatorUser?scope.row.creatorUser.name:''}}</span>
                    </el-table-column>
                    <el-table-column
                            label="修改时间">
                        <pretty-date-time slot-scope="scope" :value="scope.row.editedAt"/>
                    </el-table-column>
                    <el-table-column
                            label="修改用户">
                        <span slot-scope="scope">{{scope.row.editorUser?scope.row.editorUser.name:''}}</span>
                    </el-table-column>
                    <el-table-column
                            label="操作" width="180">
                        <template slot-scope="scope">
                            <el-link icon="el-icon-edit" @click="editRow(scope.row)">修改</el-link>
                            <el-link icon="el-icon-setting" @click="configRow(scope.row)">配置</el-link>
                            <el-link icon="el-icon-delete" @click="deleteRow(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="clear"></div>
        <div class="magin10"></div>
        <div class="foot" v-if="data">
            <el-pagination
                    layout="prev, pager, next" background
                    :total="data.totalElements" :current-page="data.number+1"
                    @current-change="fetchData($event)">
            </el-pagination>
        </div>
        <el-dialog v-if="model" :title="model.id?'修改门户':'添加门户'" :visible.sync="dialogFormVisible">
            <el-form ref="form" :model="model" label-width="120px" :rules="rules">
                <el-form-item label="门户名称" prop="name">
                    <el-input v-model="model.name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import portalService from '../service/portal'

    export default {
        name: "PortalAdmin",
        data() {
            return {
                data: null,
                searchModel: {
                    id: null,
                    nameLike: null
                },
                searchParams: {
                    id: null,
                    nameLike: null
                },
                dialogFormVisible: false,
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入门户名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ]
                }
            }
        },
        created(){
            this.fetchData(1)
        },
        methods: {
            async fetchData(page) {
                const params = Object.assign({},this.searchParams,{page: page - 1, size: 10})
                const response = await portalService.listPortals(params)
                this.data = response.data
            },
            indexMethod(index) {
                return this.data.number * this.data.size + index + 1
            },
            search(){
                this.searchParams = JSON.parse(JSON.stringify(this.searchModel))
                this.fetchData(1)
            },
            addRow(){
                this.model = {
                    name: null
                }
                this.dialogFormVisible = true
            },
            editRow(row) {
                portalService.getPortal(row.id).then(response => {
                    this.model = response.data
                    this.dialogFormVisible = true
                })
            },
            submitForm() {
                this.$refs.form.validate().then(() => {
                    if (this.model.id) {
                        portalService.updatePortal(this.model).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number+1)
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '修改失败!'
                            })
                        })
                    } else {
                        portalService.addPortal(this.model).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number+1)
                            this.$message({
                                type: 'success',
                                message: '添加成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '添加失败!'
                            })
                        })
                    }
                }).catch(()=>{})
            },
            configRow(row) {
                this.$router.push("/main/portal-config/"+row.id)
            },
            deleteRow(row){
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    portalService.deletePortal(row.id).then(()=>{
                        if (this.data.content.length > 1) {
                            this.data.content.splice(this.data.content.indexOf(row), 1)
                        } else {
                            this.fetchData(this.data.number>0?this.data.number:1)
                        }
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    }).catch(()=>{
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        }
    }
</script>
<style scoped>
    .el-link+.el-link{
        margin-left: 5px;
    }
    .search-form >>> .el-form-item__label{
        color: var(--color2);
    }
</style>
